export default "__VITE_ASSET__DL_PJOV3__"